require('./sass/base.sass');

require('../sma.admin/sass/components/grid.sass');

// Surveys dependancies
require('./sass/surveys/survey.sass');
require('../sma.applicant/surveys/index');

module.exports = {
	renderRC: require('sma.admin/components/react/render').default,

	SystemAlerts: require('sma.common/components/react/components/SystemAlerts').default,

	ajax: require('sma.common/ajax'),
	ReviewerAssignments: require('sma.reviewer/assignments_list'),
	ReviewMode: require('sma.reviewer/reviewmode').ReviewMode,
	ReviewsTab: require('sma.reviewer/reviewmode').ReviewsTab,
	ApplicationPreview: require('sma.reviewer/reviewmode').ApplicationPreview,
	Account: require('sma.accounts/account').Account,
	CancelDeleteAccount: require('sma.accounts/account').CancelDeleteAccount,
	NotificationPreferences: require('sma.accounts/account').NotificationPreferences,
	ApplicationNotes: require('sma.admin/awards/manage/application_notes'),
	surveyStart: require('sma.reviewer/survey'),
	forms: require('sma.common/components/forms'),
	oneTrust: require('sma.common/components/one_trust'),
	components: {
		CookieBanner: require('sma.common/components/cookie_banner'),
		JumpToDropdown: require('sma.admin/components/dropdowns/jump_dropdown'),
		modals: require('sma.common/components/modals'),
		MobileMenu: require('sma.applicant/components/mobile_menu').MobileMenu,
		FilePreviewer: require('sma.common/components/file_previewer'),
		Modal: require('sma.common/components/modals'),
	},
	EmailVerification: require('sma.common/email_verification.js'),
	RecoveryCodesLow: require('sma.common/recovery_codes_low.js'),
	downloads: {
		DownloadModal: require('sma.common/downloads').DownloadModal,
		DownloadPoll: require('sma.common/downloads').DownloadPoll,
	},
	amplitude: require('sma.common/components/amplitude'),
};
